import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {DpsModel} from '../model/dps.model.';

@Injectable({
    providedIn: 'root'
})
export class DpsService {

    private data = new Array<DpsModel>();

    constructor(private db: AngularFirestore) {
        this.loadData();
    }

    listAll() {
        return this.data.sort(this.compare);
    }

    getByName(name: string) {
        if (!name) {
            return;
        }
        return this.data
            .filter(object => object.name == name)[0];
    }

    async searchByName(name: string) : Promise<DpsModel> {
        return await this.db.firestore.collection('dps').where('name', '==', name).get().then(querySnapshot => {
            if(querySnapshot.docs.length > 0) {
                return querySnapshot.docs[0].data() as DpsModel;
            }else{
                return null;
            }
        });
    }

    private compare(province1, province2) {

        let comparison = 0;

        if (province1.name > province2.name) {
            comparison = 1;
        } else if (province1.name < province2.name) {
            comparison = -1;
        }

        return comparison;

    }

    public loadData() {
        this.db.firestore.collection('dps')
            .onSnapshot({includeMetadataChanges: true}, (snapshot) => {
                snapshot.docChanges().forEach((change) => {
                    this.data.push(change.doc.data() as DpsModel);
                });
            });
    }


}
